import {
  CenteredFadeInSpinner,
  CenteredMessage,
  FeatureFlagsContext,
} from '@tableau/data-catalog-shared';
import * as React from 'react';
import { Query } from 'react-apollo';

import { Messages } from '../../../gen-src/Localize';
import { DatabaseTableQuery, DatabaseTableQuery_databaseTables, DatabaseTableQueryVariables } from '../../../gen-src/queries/DatabaseTableQuery';
import { DatabaseTableQueryGql } from '../../queries/DatabaseTableQueryGql';
import { renderQueryResult } from '../renderQueryResult';
import { createRenderDataWithErrorFunction, renderError, renderNoData } from '../widgets/ErrorMessageWidgets';

export type TableQueryWrapperProps = {
  readonly tableId: string;
  readonly children: (result: DatabaseTableQuery_databaseTables) => React.ReactNode;
};

export const TableQueryWrapper = (props: TableQueryWrapperProps) => {
  const { publishedConnectionsLineageEnabled } = React.useContext(FeatureFlagsContext);

  const renderTableData = React.useCallback(
    (data: DatabaseTableQuery): React.ReactNode => {
      const table = data.databaseTables ? data.databaseTables[0] : null;
      if (table) {
        return props.children(table);
      } else {
        return <CenteredMessage message={Messages.ErrorItemNotFound()} />;
      }
    },
    [props]
  );

  return (
    <Query<DatabaseTableQuery, DatabaseTableQueryVariables>
      query={DatabaseTableQueryGql}
      variables={{ tableId: props.tableId, publishedConnectionsLineageEnabled }}
    >
      {result => renderQueryResult(result, {
        renderLoading: () => <CenteredFadeInSpinner />,
        renderData: renderTableData,
        renderNoData: renderNoData,
        renderDataWithError: createRenderDataWithErrorFunction(renderTableData),
        renderError: renderError,
      })}
    </Query>
  );
}
